// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vio-table-container {
  position: relative; }
  .vio-table-container th,
  .vio-table-container td {
    color: #fff;
    position: unset; }
  .vio-table-container th {
    position: unset !important; }

.vio-report-container {
  height: 60vh; }

.map-container-vd {
  height: 40vh;
  width: 90vw; }

.vio-table {
  height: 45vh;
  overflow: auto; }

.vio-table::-webkit-scrollbar {
  width: 0.5em; }

.vio-table::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); }

.vio-table::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey; }

.vd-map-container {
  display: flex;
  justify-content: center;
  height: 60vh; }

.vd-tab-container {
  width: 90vw;
  margin: auto; }

.vd-expanded {
  position: absolute;
  top: 10%;
  height: 90vh !important;
  background-color: #050e25;
  z-index: 100;
  left: 9%; }

.vio-graph-container {
  display: flex;
  justify-content: center; }
  .vio-graph-container .tab-content:last-child > .active {
    display: flex;
    height: 60vh; }

.vio-footer {
  margin-top: 3rem; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/ViolationDataReport/style.scss"],"names":[],"mappings":"AACA;EACE,kBAAkB,EAAA;EADpB;;IAgBI,WAAW;IACX,eAAe,EAAA;EAjBnB;IAqBI,0BAA0B,EAAA;;AAI9B;EACE,YAAY,EAAA;;AAUd;EACE,YAAY;EACZ,WAAW,EAAA;;AAMb;EACE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,YAAY,EAAA;;AAGd;EACE,4CAA4C,EAAA;;AAG9C;EACE,0BAA0B;EAC1B,4BAA4B,EAAA;;AAG9B;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACI,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,QAAQ,EAAA;;AAMZ;EACE,aAAa;EACb,uBAAuB,EAAA;EAFzB;IAII,aAAa;IACb,YAAY,EAAA;;AAIhB;EACE,gBAAgB,EAAA","sourcesContent":["\n.vio-table-container {\n  position: relative;\n\n\n  .table-button {\n  }\n\n  .table-expanded {\n  }\n\n  table {\n    // position: absolute;\n  }\n\n  th,\n  td {\n    color: #fff;\n    position: unset;\n  }\n\n  th {\n    position: unset !important;\n  }\n}\n\n.vio-report-container{\n  height: 60vh;\n\n  canvas {\n  }\n\n  #graph {\n  }\n\n}\n\n.map-container-vd {\n  height: 40vh;\n  width: 90vw;\n  // box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\n  //   rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\n  //   rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n.vio-table {\n  height: 45vh;\n  overflow: auto;\n}\n\n.vio-table::-webkit-scrollbar {\n  width: 0.5em;\n}\n\n.vio-table::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.vio-table::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n}\n\n.vd-map-container {\n  display: flex;\n  justify-content: center;\n  height: 60vh;\n}\n\n.vd-tab-container {\n  width: 90vw;\n  margin: auto;\n}\n\n.vd-expanded {\n    position: absolute;\n    top: 10%;\n    height: 90vh !important;\n    background-color: #050e25;\n    z-index: 100;\n    left: 9%;\n}\n\n.vio-button-box {\n}\n\n.vio-graph-container {\n  display: flex;\n  justify-content: center;\n  .tab-content:last-child > .active {\n    display: flex;\n    height: 60vh;\n  }\n}\n\n.vio-footer {\n  margin-top: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
